var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    transform: "matrix(1 0 0 -1 0 38)",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_294_1395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 7 31)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_294_1395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5991 15.0002L20.3991 20.1502L17.8241 17.5752C17.4408 17.1919 16.9658 17.0002 16.3991 17.0002C15.8325 17.0002 15.3575 17.1919 14.9741 17.5752L9.69913 22.9002C9.5158 23.0835 9.41997 23.3127 9.41163 23.5877C9.4033 23.8627 9.49913 24.1002 9.69913 24.3002C9.88247 24.4835 10.1158 24.5752 10.3991 24.5752C10.6825 24.5752 10.9158 24.4835 11.0991 24.3002L16.3991 19.0002L18.9741 21.5752C19.3575 21.9585 19.8325 22.1502 20.3991 22.1502C20.9658 22.1502 21.4408 21.9585 21.8241 21.5752L26.9991 16.4002V18.0002C26.9991 18.2835 27.095 18.521 27.2866 18.7127C27.4783 18.9044 27.7158 19.0002 27.9991 19.0002C28.2825 19.0002 28.52 18.9044 28.7116 18.7127C28.9033 18.521 28.9991 18.2835 28.9991 18.0002V14.0002C28.9991 13.7169 28.9033 13.4794 28.7116 13.2877C28.52 13.096 28.2825 13.0002 27.9991 13.0002H23.9991C23.7158 13.0002 23.4783 13.096 23.2866 13.2877C23.095 13.4794 22.9991 13.7169 22.9991 14.0002C22.9991 14.2835 23.095 14.521 23.2866 14.7127C23.4783 14.9044 23.7158 15.0002 23.9991 15.0002H25.5991Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthUp);
export default __webpack_public_path__ + "static/media/health_up.6122dc79d1054ba5beb333a27674a6bb.svg";
export { ForwardRef as ReactComponent };